import React, { useEffect, useMemo } from 'react'
import { Panel } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'
import PivotView from './PivotView'
import { getDataCols } from 'tyan/public/components/column'
import Message from 'tyan/public/components/FormMessage'

const PivotManager = props => {
	const { me, setState, me: { state: { showed = false, data } } } = useInstData(props)
	const { config, view, onClose, onGetData } = props

	const { pivot, columns, settings, otherSettings, calcData, cancelled } = useMemo(() => {
		const { groups, values, views } = config.pivot
		const viewData = views[view]
		if (!viewData) {
			return { cancelled: true }
		}

		const { groups: viewGroups, values: viewValues, settings = {}, otherSettings = {}, columns, calcData } = viewData
		const pivot = {
			groups: viewGroups ? Array.isArray(viewGroups[0]) ? viewGroups : viewGroups.map(v => groups?.find(g => g[0] == v)).filter(o => o) : groups,
			values: viewValues ? Array.isArray(viewValues[0]) ? viewValues : viewValues.map(v => values?.find(g => g[0] == v)).filter(o => o) : values
		}

		if (pivot.groups && pivot.values) {
			return { pivot, settings, otherSettings }
		}
		return { columns: columns || config.columns, settings, otherSettings, calcData }
	}, [])

	if (cancelled) {
		onClose?.()
		return null
	}

	const doGetData = () => {
		const setData = list => {
			if (me.unmounted) return

			if (pivot === undefined) {
				const cols = getDataCols(columns)
				const doCalc = calcData || (() => {
					const trans = {
						_date: v => Tyan.Date.dateString(v),
						_datetime: v => Tyan.Date.datetimeString(v)
					}
					const dateColNames = cols.filter(col => ['_date', '_datetime'].includes(col.type))
					return data => {
						dateColNames.forEach(({ name, type }) => data[name] = data[name]
							? data[name] === Tyan.Date.nullDate
								? ''
								: trans[type](Tyan.Date.utcToLocal(data[name]))
							: ''
						)
						return data
					}
				})()

				list.forEach(data => {
					delete data.id
					cols.forEach(col => col.field && col.field !== col.name && delete data[col.field])
				})
				list = list.map(doCalc)
			}
			setState({ data: list })
		}

		onGetData ? onGetData(columns, pivot, setData) : onClose && onClose()
	}

	useEffect(() => {
		if (cancelled)
			return

		const checkHeight = () => {
			me.container && me.container.clientHeight
				? (!me.unmounted && setState({ showed: true }))
				: setTimeout(checkHeight, 100)
		}
		setTimeout(checkHeight, 100)
		doGetData()
	}, [])

	return <>
		<Panel layout='fit' margin={"5 10 10 10"} shadow >
			{
				!data
					? <Message text='数据加载中，请稍等 ...' onCancel={onClose} showSpinner />
					: <div style={{ width: '100%', height: '100%' }}>
						<div /* id='pr1'  */ style={{ /* padding: '10px 10px 10px 10px',  */width: '100%', height: '100%' }}
							ref={ref => ref && (me.container = ref)}
						>
							{showed && <PivotView {...{ data, onClose, settings, otherSettings }} /> || null}
						</div>
					</div>
			}
		</Panel>
	</>
}

export default PivotManager